export default __webpack_public_path__ + "static/media/divolight.2a639904.svg";